import { ApiParams, ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import {
  DeviceGroupModel,
  DeviceGroupReqModel,
  MoveDevicesToGroupReqModel
} from '@shared/models/digital-signage/device-groups.model';

export const getDeviceGroups = async (
  params?: ApiParams
): Promise<ApiResponse<DeviceGroupModel>> => {
  const response = await axiosInstance.get('/signage/device-groups/getter', {
    params
  });
  return response.data;
};

export const getDeviceGroupsList = async (): Promise<DeviceGroupModel[]> => {
  const response = await axiosInstance.get('/signage/device-groups');
  return response.data;
};

export const getDeviceGroupById = async (
  id: string
): Promise<DeviceGroupModel> => {
  const response = await axiosInstance.get(`/signage/device-groups/${id}`);
  return response.data;
};

export const createDeviceGroup = async (
  body: DeviceGroupReqModel
): Promise<DeviceGroupModel> => {
  const response = await axiosInstance.post('/signage/device-groups', body);
  return response.data;
};

export const editDeviceGroup = async (
  id: string,
  body: DeviceGroupReqModel
): Promise<DeviceGroupModel> => {
  const response = await axiosInstance.put(
    `/signage/device-groups/${id}`,
    body
  );
  return response.data;
};

export const deleteDeviceGroup = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/signage/device-groups/${id}`);
};

export const deleteDeviceGroupsMany = async (ids: string[]): Promise<void> => {
  await axiosInstance.delete('/signage/device-groups/many', { data: { ids } });
};

export const moveDevicesToGroup = async (
  body: MoveDevicesToGroupReqModel
): Promise<void> => {
  await axiosInstance.put('/signage/device-groups/move', body);
};
